import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type ModalErrorMessage = {
    title?: string;
    description?: string;
    action?: 'refresh' | '';
};

export type ToggleErrorModalArgs = ModalErrorMessage & {
    isVisible?: boolean;
};

type UseErrorModalValue = {
    toggleErrorModal: (_args: ToggleErrorModalArgs) => void;
    isVisible: boolean;
    errorMessage: ModalErrorMessage;
};

const defaultMessage = {
    title: '',
    description: '',
};

/**
 * useErrorModal hook to return the error modal state and error message
 *
 * @returns {object}
 */
export default function useErrorModal(): UseErrorModalValue {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [errorMessage, setErrorMessage] =
        useState<ModalErrorMessage>(defaultMessage);

    /**
     * Toggle the error modal state
     * @param params
     */
    function toggleErrorModal({
        title,
        description,
        isVisible = false,
        action = '',
    }: ToggleErrorModalArgs): void {
        setIsVisible(isVisible);
        setErrorMessage({
            action,
            title: isVisible ? title : '',
            // eslint-disable-next-line prettier/prettier
            description: isVisible ? description || t('errors.genericDescription') : '',
        });
    }

    return { toggleErrorModal, isVisible, errorMessage };
}
